export const marketingJa = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'フリー・クイックスタート',
  'marketing.free.seo.description':
    'Grymwyrd クイックスタートを無料で入手 — ルールと今夜遊べるワンショット・アドベンチャー。薄明かりの世界へ。',
  'marketing.free.eyebrow': 'あなたの無料の通行権',
  'marketing.free.heading': '薄明かりの世界へ — 無料で',
  'marketing.free.subheadLead': '',
  'marketing.free.quickstartName': 'Grymwyrd クイックスタート',
  'marketing.free.subheadTail':
    '— コア・ルールと今夜すぐに遊べるワンショット・アドベンチャー。どこへ送ればよいかお知らせください。',
  'marketing.free.benefit.rules.title': 'ルールブック',
  'marketing.free.benefit.rules.body': 'プレイに必要なすべてをクイックスタートに凝縮。',
  'marketing.free.benefit.oneShot.title': 'ワンショット',
  'marketing.free.benefit.oneShot.body': '初夜に遊べる、すぐに実行可能なホラー・アドベンチャー。',
  'marketing.free.benefit.livingWorld.title': 'リヴィング・ワールド',
  'marketing.free.benefit.livingWorld.body': '百科事典、マップ、毎週の新しいコンテンツへのリンク。',
  'marketing.free.playInstead.heading': 'それより、遊んでみたい？',
  'marketing.free.playInstead.body':
    'キャラクターを作成して10分間のソロ体験を開始 — 購入の必要なし、拘束なし。',
  'marketing.free.playInstead.cta': 'キャラクターを作成',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'エラーが発生しました。しばらく後に再度お試しください。',
  'marketing.leadForm.ready': 'クイックスタートの準備ができました。',
  'marketing.leadForm.downloadCta': 'クイックスタートをダウンロード',
  'marketing.leadForm.alsoEmailed': 'リンクはメールボックスにも送信しました。',
  'marketing.leadForm.checkInbox': 'メールボックスをご確認ください — クイックスタートが間もなく到着します。',
  'marketing.leadForm.emailPlaceholder': 'you@example.com',
  'marketing.leadForm.emailAriaLabel': 'メール・アドレス',
  'marketing.leadForm.defaultCta': 'クイックスタートを送信',
  'marketing.leadForm.privacyNote':
    'スパムなし — クイックスタートと時々のロア・ドロップのみ。いつでも購読解除できます。',
}
